import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Grid,
  GridItem,
  VStack,
  HStack,
  Badge,
  Icon,
  Flex,
  List,
  ListItem,
  ListIcon,
  Divider,
  SimpleGrid,
  Image,
  useColorModeValue
} from '@chakra-ui/react';
import {
  FaCheck,
  FaStar,
  FaCrown,
  FaGraduationCap,
  FaVideo,
  FaUsers,
  FaDownload,
  FaCertificate,
  FaHeadset,
  FaChartLine,
  FaBookOpen,
  FaClock,
  FaWhatsapp,
  FaPhone
} from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const MotionBox = motion(Box);

const PacksPage = () => {
  const [activeNiveau, setActiveNiveau] = useState("BAC");
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';

  useEffect(() => {
    // Preserving the existing data structure with updated educational text
    setTimeout(() => {
      setPacks([
        {
          id: 1,
          nameAr: "من لول للخر | السنة التاسعة",
          price: 974,
          originalPrice: 1779,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "9eme",
          isPopular: false,
          color: "#3182CE",
          description: "باقة شاملة لتلاميذ السنة التاسعة تحتوي على جميع المواد الأساسية",
          features: [
            "رياضيات ومواد العلوم",
            "اللغات (فرنسية، انجليزية، عربية)",
            "حصص مباشرة تفاعلية (Lives) 🔴",
            "تسجيلات الحصص المباشرة للمراجعة",
            "ملخصات شاملة لجميع المواد (PDF)",
            "امتحانات تقييمية مع الإصلاح",
            "حصص تحفيزية وتنمية الذات"
          ]
        },
        {
          id: 2,
          nameAr: "من لول للخر | السنة الثامنة",
          price: 974,
          originalPrice: 1779,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "8eme",
          isPopular: false,
          color: "#805AD5",
          description: "باقة شاملة لتلاميذ السنة الثامنة لضمان التفوق الدراسي",
          features: [
            "رياضيات ومواد العلوم",
            "اللغات الأساسية",
            "حصص مباشرة تفاعلية (Lives) 🔴",
            "تسجيلات الحصص المباشرة",
            "ملخصات شاملة بصيغة PDF",
            "امتحانات تدريبية دورية",
            "متابعة بيداغوجية مستمرة"
          ]
        },
        {
          id: 3,
          nameAr: "من لول للخر | السنة السابعة",
          price: 947,
          originalPrice: 1699,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "7eme",
          isPopular: false,
          color: "#D69E2E",
          description: "أفضل انطلاقة لتلاميذ السنة السابعة مع برنامج متكامل",
          features: [
            "رياضيات وعلوم الحياة والأرض",
            "برنامج اللغات والتقنية",
            "حصص مباشرة تفاعلية (Lives) 🔴",
            "إمكانية مشاهدة التسجيلات",
            "تلاخيص مبسطة لجميع الدروس",
            "امتحانات تقييمية شاملة",
            "دعم نفسي وتوجيه مدرسي"
          ]
        },
        {
          id: 4,
          nameAr: "من لول للخر | السنة الثانية",
          price: 947,
          originalPrice: 1240,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "2eme",
          isPopular: false,
          color: "#38B2AC",
          description: "باقة متخصصة لتلاميذ السنة الثانية بمختلف الشعب",
          features: [
            "رياضيات واختصاصات الشعبة",
            "إدارة واقتصاد (Gestion / Éco)",
            "حصص مباشرة تفاعلية (Lives) 🔴",
            "بنك تسجيلات الدروس المباشرة",
            "ملخصات منهجية وPDF",
            "سلسلة تمارين مصححة",
            "مرافقة تربوية متواصلة"
          ]
        },
        {
          id: 5,
          nameAr: "من لول للخر | السنة الثالثة",
          price: 947,
          originalPrice: 1240,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "3eme",
          isPopular: false,
          color: "#E53E3E",
          description: "التحضير الجيد للبكالوريا يبدأ من السنة الثالثة",
          features: [
            "المواد الأساسية لكل شعبة",
            "Gestion و Économie وشعب العلوم",
            "حصص مباشرة تفاعلية (Lives) 🔴",
            "الوصول لكافة تسجيلات الحصص",
            "تلاخيص وامتحانات تدريبية",
            "تمارين وفق المنهج الرسمي",
            "توجيه جامعي ومدرسي مبكر"
          ]
        },
        {
          id: 6,
          nameAr: "من لول للخر | البكالوريا",
          price: 1247,
          originalPrice: 1799,
          currency: "TND",
          duration: 1,
          durationType: "years",
          niveau: "BAC",
          isPopular: true,
          color: primaryColor,
          description: "الباقة الذهبية لتلاميذ البكالوريا لضمان النجاح بتفوق",
          features: [
            "مراجعة شاملة لكافة المواد",
            "Maths, Gestion, Éco, Hist, Géo",
            "حصص مباشرة يومية (Lives) 🔴",
            "أرشيف كامل لتسجيلات الدروس",
            "ملخصات البكالوريا الذهبية",
            "إصلاح البكالوريات السابقة",
            "حصص مكثفة للمراجعة النهائية"
          ]
        }
      ]);
      setLoading(false);
    }, 500);
  }, []);

  const formatDuration = (duration, type) => {
    const typeMap = {
      'months': duration === 1 ? 'شهر' : 'أشهر',
      'years': duration === 1 ? 'سنة' : 'سنوات'
    };
    return `${duration} ${typeMap[type]}`;
  };

  const niveauGroups = {
    "BAC": "البكالوريا",
    "3eme": "السنة الثالثة",
    "2eme": "السنة الثانية",
    "9eme": "السنة التاسعة",
    "8eme": "السنة الثامنة",
    "7eme": "السنة السابعة"
  };

  const NiveauButton = ({ niveau, label, isActive, onClick }) => (
    <Button
      onClick={onClick}
      size="lg"
      variant={isActive ? "solid" : "outline"}
      bg={isActive ? primaryColor : "transparent"}
      color={isActive ? secondaryColor : "gray.600"}
      borderColor={isActive ? primaryColor : "gray.200"}
      borderWidth="2px"
      borderRadius="2xl"
      px={10}
      py={8}
      h="auto"
      _hover={{
        bg: isActive ? "#E0B817" : `${primaryColor}10`,
        borderColor: primaryColor,
        transform: 'translateY(-2px)'
      }}
      fontFamily="Tajawal, sans-serif"
      fontWeight="900"
      leftIcon={<Icon as={FaGraduationCap} ml={2} />}
      transition="all 0.3s"
      boxShadow={isActive ? "xl" : "none"}
    >
      {label}
    </Button>
  );

  const PackCard = ({ pack }) => {
    const handleWhatsAppClick = () => {
      window.open(`https://wa.me/21622779137`, '_blank');
    };

    const handlePhoneClick = () => {
      window.open(`tel:+21622779137`, '_blank');
    };

    return (
      <MotionBox
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        whileHover={{ y: -10 }}
        h="100%"
      >
        <Box
          bg="white"
          boxShadow={pack.isPopular ? "2xl" : "xl"}
          borderRadius="3xl"
          overflow="hidden"
          position="relative"
          border="2px solid"
          borderColor={pack.isPopular ? primaryColor : "gray.100"}
          transition="all 0.3s"
          h="100%"
          display="flex"
          flexDirection="column"
        >
          {pack.isPopular && (
            <Box
              position="absolute"
              top={0}
              left="50%"
              transform="translateX(-50%)"
              bg={primaryColor}
              color={secondaryColor}
              px={8}
              py={2}
              borderBottomRadius="2xl"
              fontWeight="900"
              fontSize="sm"
              fontFamily="Tajawal, sans-serif"
              zIndex={2}
              boxShadow="md"
            >
              العرض الأكثر طلباً
            </Box>
          )}

          <VStack p={8} spacing={6} align="stretch" flex={1}>
            <VStack spacing={4} align="center">
              <Box
                p={4}
                bg={`${pack.color}15`}
                borderRadius="2xl"
                color={pack.color}
              >
                <Icon as={FaCrown} boxSize={8} />
              </Box>
              <VStack spacing={1}>
                <Heading size="lg" color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="900" textAlign="center">
                  {pack.nameAr}
                </Heading>
                <Text fontSize="md" color="gray.500" textAlign="center" fontFamily="Tajawal, sans-serif" fontWeight="600">
                  {pack.description}
                </Text>
              </VStack>
            </VStack>

            <Box textAlign="center" py={4} bg="gray.50" borderRadius="2xl">
              <VStack spacing={0}>
                {pack.originalPrice && (
                  <Text
                    fontSize="lg"
                    color="red.400"
                    textDecoration="line-through"
                    fontFamily="Tajawal, sans-serif"
                    fontWeight="700"
                  >
                    {pack.originalPrice} {pack.currency}
                  </Text>
                )}
                <HStack align="center" justify="center" spacing={2}>
                  <Text fontSize="4xl" fontWeight="900" color={secondaryColor} fontFamily="Tajawal, sans-serif">
                    {pack.price}
                  </Text>
                  <Text fontSize="2xl" color="gray.600" fontFamily="Tajawal, sans-serif" fontWeight="700">
                    {pack.currency}
                  </Text>
                </HStack>
                <Text fontSize="md" color="gray.500" fontFamily="Tajawal, sans-serif" fontWeight="700">
                  لكامل السنة الدراسية
                </Text>
              </VStack>
            </Box>

            <List spacing={4}>
              {pack.features.map((feature, index) => (
                <ListItem key={index}>
                  <HStack spacing={3} align="flex-start">
                    <ListIcon as={FaCheck} color={primaryColor} mt={1} />
                    <Text fontSize="md" fontFamily="Tajawal, sans-serif" fontWeight="700" color="gray.700">
                      {feature}
                    </Text>
                  </HStack>
                </ListItem>
              ))}
            </List>

            <Box mt="auto" pt={6}>
              <VStack spacing={3}>
                <Button
                  leftIcon={<FaWhatsapp />}
                  w="100%"
                  size="lg"
                  bg="#25D366"
                  color="white"
                  _hover={{ bg: '#20bd5a', transform: 'scale(1.02)' }}
                  fontFamily="Tajawal, sans-serif"
                  fontWeight="900"
                  fontSize="md"
                  onClick={handleWhatsAppClick}
                  borderRadius="xl"
                  boxShadow="lg"
                >
                  سجل عبر واتساب
                </Button>
                <Button
                  leftIcon={<FaPhone />}
                  w="100%"
                  size="lg"
                  variant="outline"
                  borderColor={secondaryColor}
                  color={secondaryColor}
                  _hover={{ bg: `${secondaryColor}10` }}
                  fontFamily="Tajawal, sans-serif"
                  fontWeight="800"
                  fontSize="md"
                  onClick={handlePhoneClick}
                  borderRadius="xl"
                >
                  اتصل بنا للاستفسار
                </Button>
              </VStack>
            </Box>
          </VStack>
        </Box>
      </MotionBox>
    );
  };

  return (
    <Box dir="rtl" bg="gray.50">
      <Header />

      {/* Hero Section */}
      <Box
        bgGradient={`linear(to-l, ${secondaryColor}, gray.800)`}
        py={{ base: 20, md: 32 }}
        color="white"
        position="relative"
        overflow="hidden"
      >
        <Box
          position="absolute"
          top="-10%"
          right="-10%"
          width="500px"
          height="500px"
          bg={primaryColor}
          opacity="0.05"
          borderRadius="full"
          filter="blur(120px)"
        />

        <Container maxW="1400px" textAlign="center">
          <VStack spacing={8}>
            <Badge
              bg={primaryColor}
              color={secondaryColor}
              px={6}
              py={2}
              borderRadius="full"
              fontSize="md"
              fontFamily="Tajawal, sans-serif"
              fontWeight="800"
            >
              عروض السنة الدراسية 2024-2025
            </Badge>
            <Heading fontSize={{ base: '4xl', md: '6xl' }} fontFamily="Tajawal, sans-serif" fontWeight="900">
              اختر الباقة المناسبة للتلميذ
            </Heading>
            <Text fontSize="xl" maxW="3xl" fontFamily="Tajawal, sans-serif" color="whiteAlpha.900" lineHeight="1.8">
              باقات تعليمية شاملة ومصممة خصيصاً لتلبية احتياجات التلاميذ في كافة المستويات، مع مرافقة بيداغوجية مستمرة طوال السنة.
            </Text>

            <HStack spacing={{ base: 4, md: 10 }} mt={8} flexWrap="wrap" justify="center">
              <VStack>
                <Text fontSize="4xl" fontWeight="900" color={primaryColor}>30%</Text>
                <Text fontSize="md" fontWeight="700" fontFamily="Tajawal, sans-serif">تخفيضات استثنائية</Text>
              </VStack>
              <Divider orientation="vertical" h="50px" borderColor="whiteAlpha.300" display={{ base: 'none', md: 'block' }} />
              <VStack>
                <Text fontSize="4xl" fontWeight="900" color={primaryColor}>24/7</Text>
                <Text fontSize="md" fontWeight="700" fontFamily="Tajawal, sans-serif">دعم تعليمي متواصل</Text>
              </VStack>
              <Divider orientation="vertical" h="50px" borderColor="whiteAlpha.300" display={{ base: 'none', md: 'block' }} />
              <VStack>
                <Text fontSize="4xl" fontWeight="900" color={primaryColor}>100%</Text>
                <Text fontSize="md" fontWeight="700" fontFamily="Tajawal, sans-serif">برنامج رسمي معتمد</Text>
              </VStack>
            </HStack>
          </VStack>
        </Container>
      </Box>

      <Container maxW="1400px" py={20}>
        {/* Niveau Selection */}
        <VStack spacing={8} mb={16}>
          <Heading size="xl" color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="900">
            اختر المستوى التعليمي
          </Heading>
          <Box w="100%" overflowX="auto" py={4} css={{
            '&::-webkit-scrollbar': { height: '8px' },
            '&::-webkit-scrollbar-thumb': { background: primaryColor, borderRadius: '10px' }
          }}>
            <HStack spacing={4} justify={{ base: 'flex-start', md: 'center' }} minW="max-content" px={4}>
              {Object.entries(niveauGroups).map(([niveau, label]) => (
                <NiveauButton
                  key={niveau}
                  niveau={niveau}
                  label={label}
                  isActive={activeNiveau === niveau}
                  onClick={() => setActiveNiveau(niveau)}
                />
              ))}
            </HStack>
          </Box>
        </VStack>

        {/* Packs Grid */}
        <AnimatePresence mode="wait">
          <MotionBox
            key={activeNiveau}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10} justifyItems="center">
              {packs
                .filter(pack => pack.niveau === activeNiveau)
                .map((pack) => (
                  <PackCard key={pack.id} pack={pack} />
                ))}
            </SimpleGrid>
            {packs.filter(pack => pack.niveau === activeNiveau).length === 0 && (
              <Box textAlign="center" py={20}>
                <Icon as={FaClock} boxSize={16} color="gray.700" mb={4} />
                <Text fontSize="xl" color="gray.500" fontFamily="Tajawal, sans-serif" fontWeight="700">
                  قريباً جـداً.. انتظروا بقية العروض
                </Text>
              </Box>
            )}
          </MotionBox>
        </AnimatePresence>

        {/* FAQ Section Redesigned */}
        <Box mt={32}>
          <VStack spacing={12}>
            <VStack spacing={4} textAlign="center">
              <Heading size="2xl" color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="900">
                أسئلة شائعة حول العروض
              </Heading>
              <Text fontSize="lg" color="gray.500" maxW="2xl" fontFamily="Tajawal, sans-serif" fontWeight="600">
                كل ما تريد معرفته عن التسجيل وكيفية الاستفادة من المحتوى التعليمي.
              </Text>
            </VStack>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="100%">
              {[
                {
                  question: "هل الباقة تشمل كامل السنة الدراسية؟",
                  answer: "نعم، بمجرد الاشتراك تحصل على وصول كامل لكافة الدروس والتمارين والحصص المباشرة من بداية السنة إلى الامتحانات النهائية."
                },
                {
                  question: "كيف يتم تفعيل الحساب بعد الدفع؟",
                  answer: "بعد إتمام عملية الدفع وإرسال الوصل عبر واتساب، يتم تفعيل حساب التلميذ في غضون ساعة واحدة وتزويده بكافة معلومات الدخول."
                },
                {
                  question: "هل يمكن لشخصين استخدام نفس الحساب؟",
                  answer: "الحساب شخصي وخاص بتلميذ واحد فقط لضمان دقة المتابعة البيداغوجية والتقييم، ولا يسمح بمشاركته."
                },
                {
                  question: "هل تقدمون ضماناً للنجاح؟",
                  answer: "نحن نوفر أفضل الأدوات والأساتذة لضمان التميز، والتزام التلميذ بمتابعة الدروس وانجاز التمارين هو المفتاح الحقيقي للنجاح."
                }
              ].map((faq, index) => (
                <Box key={index} p={8} bg="white" borderRadius="2xl" boxShadow="lg" borderLeft="6px solid" borderColor={primaryColor}>
                  <VStack align="flex-start" spacing={4}>
                    <Heading size="md" color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="900">
                      {faq.question}
                    </Heading>
                    <Text fontSize="md" color="gray.600" fontFamily="Tajawal, sans-serif" lineHeight="1.8">
                      {faq.answer}
                    </Text>
                  </VStack>
                </Box>
              ))}
            </SimpleGrid>
          </VStack>
        </Box>

        {/* Final CTA Strip */}
        <Box
          mt={32}
          bgGradient={`linear(to-l, ${primaryColor}, #E0B817)`}
          borderRadius="3xl"
          p={{ base: 10, md: 16 }}
          textAlign="center"
          boxShadow="2xl"
        >
          <VStack spacing={8}>
            <Heading size="xl" color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="900">
              لا تضيع فرصة التميز الدراسي
            </Heading>
            <Text fontSize="xl" color={secondaryColor} maxW="3xl" fontFamily="Tajawal, sans-serif" fontWeight="700">
              سجل الآن وانطلق في رحلة النجاح مع أفضل منصة تعليمية للتلاميذ في تونس.
            </Text>
            <HStack spacing={4} flexWrap="wrap" justify="center">
              <Button
                leftIcon={<FaWhatsapp />}
                size="xl"
                h="70px"
                px={12}
                bg={secondaryColor}
                color="white"
                _hover={{ bg: 'black', transform: 'scale(1.05)' }}
                fontFamily="Tajawal, sans-serif"
                fontWeight="900"
                onClick={() => window.open('https://wa.me/21622779137', '_blank')}
                borderRadius="2xl"
                boxShadow="xl"
              >
                سجل تلميذك الآن
              </Button>
            </HStack>
          </VStack>
        </Box>
      </Container>

      <Footer />
    </Box>
  );
};

export default PacksPage;
